/**
 * 指定證件上傳元件的配置介面
 */
export interface RequiredDocumentConfig {
  /** 證件名稱（如「六小時教育訓練證明」、「堆高機證照」） */
  documentName: string;
  
  /** 證件說明文字（可選） */
  documentDescription?: string;
  
  /** 是否啟用AI解析功能 */
  aiParsing?: boolean;
  
  /** 對應的有效期限欄位名稱（可選，用於AI解析後自動填入） */
  expiryDateField?: string;
  
  /** 接受的檔案格式 */
  acceptedFormats?: string[];
  
  /** 最大檔案大小（MB） */
  maxFileSize?: number;
  
  /** 上傳提示文字 */
  uploadHint?: string;
  
  /** 是否顯示檔案大小 */
  showFileSize?: boolean;
  
  /** 是否顯示上傳時間 */
  showUploadTime?: boolean;
  
  /** 是否啟用拖拽上傳 */
  enableDragDrop?: boolean;
  
  /** 是否啟用檔案預覽（圖片檔案） */
  enablePreview?: boolean;
}

/**
 * 預設配置
 */
export const DEFAULT_REQUIRED_DOCUMENT_CONFIG: RequiredDocumentConfig = {
  documentName: '',
  documentDescription: '',
  aiParsing: false,
  expiryDateField: '',
  acceptedFormats: ['.pdf', '.jpg', '.jpeg', '.png'],
  maxFileSize: 10,
  uploadHint: '',
  showFileSize: true,
  showUploadTime: true,
  enableDragDrop: true,
  enablePreview: true
};